import get from 'lodash/get';
import { Component } from 'react';
import { withApollo } from 'react-apollo';
import ErinLogo from '../_shared/assets/erinwhite.png';
import { downloadFromS3, graphql } from '../_shared/services/utils.js';
import NewExtendedUserForm from './new-user-items/NewExtendedUserFormComponent.jsx';
import { LandingPageContainer, Logo } from './newUserLandingStyles.js';
import { RouterContext } from '../_shared/contexts';
class NewExtendedUserLandingPageComponent extends Component {
	constructor(props) {
		super(props);
		this.state = {
			accountClaim: get(props, 'location.state.accountClaim'),
			departments: null,
			company: get(
				props,
				'currentUser.company',
				get(
					props,
					'location.state.accountClaim.company',
					get(props, 'contact.company', get(props, 'company'))
				)
			),
			loaded: false,
		};
	}

	async componentDidMount() {
		const { id } = this.props.match.params;
		const contact = await graphql({ input: { id }, query: 'getContact' });
		if (contact) {
			const companyId = get(contact, 'companyId');
			let departments = await graphql({
				input: { companyId, first: 500 },
				query: 'queryDepartmentsByCompanyIdIndex',
			});
			departments = departments?.items || departments;
			let userGroups = await graphql({
				input: { companyId },
				query: 'queryUserGroupsByCompanyIdIndex',
			});
			userGroups = userGroups?.items || userGroups;
			const defaultUserGroupId = this.getUserGroupId(userGroups, 'Default');
			const noBonusUserGroupId = this.getUserGroupId(userGroups, 'Ineligible');

			const company = contact.company;
			const logo = company?.logo?.key;
			const bucket = company?.logo?.bucket || 'erin-images';
			let url;
			if (logo && bucket) {
				url = await downloadFromS3(logo, bucket);
			}
			const styles = await LandingPageContainer(company);

			this.setState({
				contact,
				defaultUserGroupId,
				departments,
				logoSrc: url,
				noBonusUserGroupId,
				styles,
				userGroups,
			});
		}
	}

	getUserGroupId = (userGroups, name) => {
		const userGroup = userGroups.find((group) => group.name === name);
		return get(userGroup, 'id');
	};

	render() {
		const { userInvite, setCurrentUser } = this.props;
		const {
			accountClaim,
			defaultUserGroupId,
			departments,
			logoSrc,
			noBonusUserGroupId,
			contact,
			styles,
		} = this.state;
		const company = get(contact, 'company');
		const whiteLabel = get(company, 'whiteLabel');
		const imageUrlToRender = whiteLabel ? logoSrc : ErinLogo;

		if (userInvite && userInvite.userId) {
			this.props.history.push('/login');
		}

		return company ? (
			<div className={styles}>
				{imageUrlToRender && (
					<img src={imageUrlToRender} alt="logo" width="350px" />
				)}
				<RouterContext.Consumer>
					{({ onAuthentication }) => (
						<NewExtendedUserForm
							contact={contact}
							whiteLabel={whiteLabel}
							accountClaim={accountClaim}
							defaultUserGroupId={defaultUserGroupId}
							noBonusUserGroupId={noBonusUserGroupId}
							setCurrentUser={setCurrentUser}
							userInvite={userInvite}
							departments={get(
								departments,
								'data.queryDepartmentsByCompanyIdIndex.items',
								[]
							)}
							onCreate={this.props.onCreate}
							onUpdateContact={this.props.onUpdateContact}
							onAuthentication={onAuthentication}
						/>
					)}
				</RouterContext.Consumer>
			</div>
		) : null;
	}
}

export default withApollo(NewExtendedUserLandingPageComponent);
